export default "skymp5-front/53830d14dea32e52691eb44033d13d5d.png";